import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/* ═══ ALTA DE SOCIO CLUB · Fase 1 (solo formulario, SIN Stripe) ═══
   Spec Guardián 2026-07-11. Saca el alta CLUB del WordPress comprometido a la
   plataforma blindada. Flujo objetivo: este formulario → pago Stripe → alta.
   En Fase 1 NO hay Stripe: el formulario recoge y valida; el endpoint (validación
   servidor + PII cifrada + consentimientos versionados) se conecta aparte.

   5 secciones: 1) Tus datos  2) Tu membresía  3) Tu acceso  4) Consentimientos  5) Pago.
   Anti-bot: honeypot oculto + tiempo mínimo de cumplimentación (rechazo <2s).
   El captcha (Turnstile/hCaptcha) se valida EN SERVIDOR; aquí va su hueco.

   Estilo de marca (blanco/mint). El front es SOLO UX: la validación que cuenta
   es la del servidor. PII (telefono, dni, direccion, fecha_nacimiento) → cifrada
   en reposo con encryptor.encrypt en el backend.

   ⚠️ Planes CLUB e "¿factura?" → PENDIENTE de confirmar por Ann (marcados abajo). */

const TEAL = '#2C6675';
const TEAL2 = '#3C8696';

// PLANES CLUB — EJEMPLO, PENDIENTE de que Ann confirme nombres/precios/periodicidad reales.
// Textos por i18n (bilingüe ES/CA · F4): funciones de t.
const planesClubEjemplo = (t) => [
  { id: 'club_mensual', nombre: t('club.planMensualNombre'), precio: '—', periodo: t('club.porMes'), desc: t('club.planMensualDesc') },
  { id: 'club_anual', nombre: t('club.planAnualNombre'), precio: '—', periodo: t('club.porAno'), desc: t('club.planAnualDesc') },
];
// "¿Cómo nos conociste?": el VALUE guardado queda en español canónico; la etiqueta se traduce.
const COMO_CONOCISTE = [
  { valor: 'Recomendación', clave: 'club.conRecomendacion' },
  { valor: 'Redes sociales', clave: 'club.conRedes' },
  { valor: 'Búsqueda en Google', clave: 'club.conGoogle' },
  { valor: 'Cartel / folleto', clave: 'club.conCartel' },
  { valor: 'Ya soy cliente presencial', clave: 'club.conPresencial' },
  { valor: 'Otro', clave: 'club.conOtro' },
];

const seccionesClub = (t) => [t('club.sec1'), t('club.sec2'), t('club.sec3'), t('club.sec4'), t('club.sec5')];

const S = {
  wrap: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
    background: 'radial-gradient(130% 70% at 50% 0%,#E1F4EF 0%,#EAF6F4 55%)',
    fontFamily: "'Montserrat', system-ui, sans-serif", padding: '34px 18px 48px',
  },
  logos: { display: 'flex', alignItems: 'center', gap: 18, marginBottom: 14 },
  card: {
    background: '#fff', borderRadius: 22, boxShadow: '0 18px 50px rgba(44,107,118,.16)',
    width: '100%', maxWidth: 500, padding: '28px 28px 26px', boxSizing: 'border-box',
  },
  stepbar: { display: 'flex', gap: 6, width: '100%', maxWidth: 500, margin: '0 auto 8px' },
  stepdot: (on) => ({ flex: 1, height: 6, borderRadius: 999, background: on ? TEAL : 'rgba(44,107,118,.18)', transition: '.25s' }),
  seccName: { textAlign: 'center', fontSize: 12.5, letterSpacing: '.08em', textTransform: 'uppercase', color: TEAL2, fontWeight: 700, margin: '0 0 14px' },
  title: { margin: '0 0 4px', fontSize: 22, color: '#16323a', fontWeight: 800, textAlign: 'center' },
  desc: { margin: '0 0 18px', color: '#33474d', fontSize: 14, textAlign: 'center' },
  label: { fontWeight: 700, fontSize: 13, color: '#16323a', display: 'block' },
  input: (err) => ({
    width: '100%', height: 46, borderRadius: 12, border: `1px solid ${err ? '#e3a6a3' : '#dbe6e7'}`, padding: '0 14px',
    fontSize: 15, outline: 'none', boxSizing: 'border-box', margin: '6px 0 4px',
    fontFamily: "'Montserrat', system-ui, sans-serif",
  }),
  err: { color: '#d9534f', fontSize: 12, margin: '0 0 8px' },
  gap: { height: 10 },
  row: { display: 'flex', gap: 12 },
  btn: (dis) => ({
    height: 48, borderRadius: 12, border: 'none', flex: 1, cursor: dis ? 'default' : 'pointer',
    fontWeight: 800, fontSize: 15.5, fontFamily: "'Montserrat', system-ui, sans-serif",
    background: dis ? '#cfe0e1' : `linear-gradient(135deg,${TEAL2},${TEAL})`, color: '#fff',
  }),
  ghost: {
    height: 48, borderRadius: 12, flex: '0 0 auto', padding: '0 20px', cursor: 'pointer',
    fontWeight: 700, fontSize: 14.5, fontFamily: "'Montserrat', system-ui, sans-serif",
    background: 'rgba(60,134,150,.10)', color: TEAL, border: '1px solid rgba(60,134,150,.35)',
  },
  nav: { display: 'flex', gap: 10, marginTop: 18 },
  planCard: (sel) => ({
    border: `2px solid ${sel ? TEAL : '#e2eeed'}`, background: sel ? 'rgba(60,134,150,.06)' : '#fff',
    borderRadius: 14, padding: '14px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10,
  }),
  chk: { display: 'flex', gap: 11, alignItems: 'flex-start', margin: '0 0 14px', cursor: 'pointer', fontSize: 13.5, color: '#16323a', lineHeight: 1.45 },
  aviso: { fontSize: 12, color: '#8a6d3b', background: '#fbf4e6', border: '1px solid #efe0c0', borderRadius: 10, padding: '9px 12px', margin: '2px 0 12px' },
};

const Req = () => <span style={{ color: '#c0564f' }}> *</span>;

const Logos = () => (
  <div style={S.logos}>
    <img src="/logo-pd.png" alt="Pilar Domínguez" style={{ height: 34, width: 'auto' }} />
    <span style={{ width: 1, height: 28, background: 'rgba(44,107,118,.3)' }} />
    <img src="/logo-mefir-trans.png" alt="Instituto MEFIR" style={{ height: 30, width: 'auto' }} />
  </div>
);

function validarDNI(dni) {
  if (!dni) return false;
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
  const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
  const str = dni.toString().toUpperCase().replace(/\s/g, '');
  if (!nifRexp.test(str) && !nieRexp.test(str)) return false;
  const nieToNum = str.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');
  const charIndex = parseInt(nieToNum.substr(0, 8), 10) % 23;
  return validChars.charAt(charIndex) === str.substr(-1);
}
const _debiles = /^(?:1234\d*|12345678|123456789|0000+|1111+|password|passw0rd|contrasena|contraseña|qwerty|abcdef|admin\d*)$/i;
function edad(fnac) {
  if (!fnac) return null;
  const h = new Date(); const n = new Date(fnac);
  let e = h.getFullYear() - n.getFullYear();
  const m = h.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && h.getDate() < n.getDate())) e--;
  return e;
}

export default function ClubAlta({ onListo = () => {}, planes = null }) {
  const { t } = useTranslation('auth');
  const SECCIONES = seccionesClub(t);
  const listaPlanes = planes || planesClubEjemplo(t);
  const [sec, setSec] = useState(0);
  const _emailInicial = (() => { try { return new URLSearchParams(window.location.search).get('email') || ''; } catch (e) { return ''; } })();
  const [f, setF] = useState({
    nombre: '', primer_apellido: '', segundo_apellido: '', email: _emailInicial, telefono: '',
    fecha_nacimiento: '', sexo: '', factura: false, dni: '',
    direccion: '', numero_piso: '', codigo_postal: '', ciudad: '', provincia: '',
    plan: '', como_conociste: '', pw1: '', pw2: '',
    honeypot: '', // anti-bot: debe quedar VACÍO
  });
  const [cons, setCons] = useState({ privacidad: false, terminos: false, salud: false, marketing: false });
  const [tocado, setTocado] = useState({});
  const [hecho, setHecho] = useState(false);
  const abierto = useRef(Date.now()); // para rechazo <2s (validado también en servidor)

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const marca = (k) => () => setTocado({ ...tocado, [k]: true });

  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email);
  const telOk = f.telefono.replace(/\s/g, '').length >= 9;
  const ed = edad(f.fecha_nacimiento);
  const mayor = ed !== null && ed >= 18;
  const dniOk = !f.factura || validarDNI(f.dni);
  const dirOk = !f.factura || (f.direccion.trim() && f.codigo_postal.trim() && f.ciudad.trim() && f.provincia.trim());
  const datosOk = f.nombre.trim() && f.primer_apellido.trim() && f.segundo_apellido.trim()
    && emailOk && telOk && f.fecha_nacimiento && mayor && f.sexo && dniOk && dirOk;

  const membresiaOk = !!f.plan;
  const reglasPw = [
    { ok: f.pw1.length >= 8, txt: t('comun.reglaMin8') },
    { ok: /[a-zA-Z]/.test(f.pw1), txt: t('comun.reglaLetra') },
    { ok: /\d/.test(f.pw1), txt: t('comun.reglaNumero') },
    { ok: f.pw1.length > 0 && !_debiles.test(f.pw1), txt: t('comun.reglaTipica') },
  ];
  const accesoOk = reglasPw.every(r => r.ok) && f.pw1 === f.pw2;
  const consentOk = cons.privacidad && cons.terminos; // obligatorios; salud/marketing opcionales

  const puedeAvanzar = [datosOk, membresiaOk, accesoOk, consentOk, true][sec];

  if (hecho) {
    return (
      <div style={S.wrap}><Logos />
        <div style={{ ...S.card, textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(60,134,150,.12)', display: 'grid', placeItems: 'center', margin: '4px auto 16px' }}>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
          </div>
          <h1 style={S.title}>{t('club.registrada')}</h1>
          <p style={S.desc}>{t('club.registrada1')}<b>{t('club.registradaStrong')}</b>{t('club.registrada2')}</p>
          <div style={S.nav}><button style={S.btn(false)} onClick={onListo}>{t('comun.volver')}</button></div>
        </div>
      </div>
    );
  }

  return (
    <div style={S.wrap}>
      <Logos />
      <div style={S.stepbar}>{SECCIONES.map((_, i) => <span key={i} style={S.stepdot(i <= sec)} />)}</div>
      <p style={S.seccName}>{sec + 1}/5 · {SECCIONES[sec]}</p>

      <div style={S.card}>
        {/* honeypot oculto (los bots lo rellenan; humanos no lo ven) */}
        <input tabIndex={-1} autoComplete="off" value={f.honeypot} onChange={set('honeypot')}
          style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }} aria-hidden="true" />

        {/* ── 1 · TUS DATOS ── */}
        {sec === 0 && (<>
          <h1 style={S.title}>{t('club.sec1')}</h1>
          <p style={S.desc}>{t('club.datosSub')}</p>

          <label style={S.label}>{t('comun.nombre')}<Req /></label>
          <input value={f.nombre} onChange={set('nombre')} placeholder={t('comun.tuNombrePlaceholder')} style={S.input(false)} /><div style={S.gap} />

          <div style={S.row}>
            <div style={{ flex: 1 }}>
              <label style={S.label}>{t('comun.primerApellido')}<Req /></label>
              <input value={f.primer_apellido} onChange={set('primer_apellido')} placeholder={t('comun.primerApellido')} style={S.input(false)} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={S.label}>{t('comun.segundoApellido')}<Req /></label>
              <input value={f.segundo_apellido} onChange={set('segundo_apellido')} placeholder={t('comun.segundoApellido')} style={S.input(false)} />
            </div>
          </div><div style={S.gap} />

          <label style={S.label}>{t('comun.email')}<Req /> <span style={{ fontWeight: 500, color: '#7d9195' }}>{t('club.seraUsuario')}</span></label>
          <input type="email" value={f.email} onChange={set('email')} onBlur={marca('email')} placeholder={t('comun.emailPlaceholder')} style={S.input(tocado.email && f.email && !emailOk)} />
          {tocado.email && f.email && !emailOk ? <p style={S.err}>{t('comun.emailInvalido')}</p> : <div style={S.gap} />}

          <label style={S.label}>{t('comun.telefono')}<Req /></label>
          <input value={f.telefono} onChange={set('telefono')} onBlur={marca('tel')} placeholder="600 000 000" style={S.input(tocado.tel && f.telefono && !telOk)} />
          {tocado.tel && f.telefono && !telOk ? <p style={S.err}>{t('club.telefonoInvalido')}</p> : <div style={S.gap} />}

          <div style={S.row}>
            <div style={{ flex: 1 }}>
              <label style={S.label}>{t('comun.fechaNacimiento')}<Req /></label>
              <input type="date" value={f.fecha_nacimiento} onChange={set('fecha_nacimiento')} style={S.input(false)} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={S.label}>{t('comun.sexo')}<Req /></label>
              <select value={f.sexo} onChange={set('sexo')} style={{ ...S.input(false), padding: '0 10px' }}>
                <option value="">{t('comun.selecciona')}</option><option value="M">{t('comun.hombre')}</option><option value="F">{t('comun.mujer')}</option><option value="Otro">{t('comun.otro')}</option>
              </select>
            </div>
          </div>
          {ed !== null && !mayor ? <p style={S.err}>{t('club.mayor18')}</p> : <div style={S.gap} />}

          {/* ¿factura? → activa DNI + dirección (PENDIENTE confirmar por Ann si el CLUB factura siempre) */}
          <label style={S.chk}>
            <input type="checkbox" checked={f.factura} onChange={e => setF({ ...f, factura: e.target.checked })} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
            <span>{t('club.factura1')}<b>{t('club.facturaStrong')}</b>{t('club.factura2')}</span>
          </label>

          {f.factura && (<>
            <label style={S.label}>{t('comun.dniNif')}<Req /></label>
            <input value={f.dni} onChange={set('dni')} onBlur={marca('dni')} placeholder="12345678Z" style={S.input(tocado.dni && f.dni && !validarDNI(f.dni))} />
            {tocado.dni && f.dni && !validarDNI(f.dni) ? <p style={S.err}>{t('club.dniInvalido')}</p> : <div style={S.gap} />}

            <label style={S.label}>{t('comun.direccion')}<Req /></label>
            <input value={f.direccion} onChange={set('direccion')} placeholder={t('comun.calleNumeroPlaceholder')} style={S.input(false)} /><div style={S.gap} />
            <div style={S.row}>
              <div style={{ flex: 1 }}><label style={S.label}>{t('comun.numPiso')}</label><input value={f.numero_piso} onChange={set('numero_piso')} placeholder="3º 2ª" style={S.input(false)} /></div>
              <div style={{ flex: 1 }}><label style={S.label}>{t('comun.cPostal')}<Req /></label><input value={f.codigo_postal} onChange={set('codigo_postal')} placeholder="08000" style={S.input(false)} /></div>
            </div><div style={S.gap} />
            <div style={S.row}>
              <div style={{ flex: 1 }}><label style={S.label}>{t('comun.ciudad')}<Req /></label><input value={f.ciudad} onChange={set('ciudad')} placeholder="Barcelona" style={S.input(false)} /></div>
              <div style={{ flex: 1 }}><label style={S.label}>{t('comun.provincia')}<Req /></label><input value={f.provincia} onChange={set('provincia')} placeholder="Barcelona" style={S.input(false)} /></div>
            </div>
          </>)}
        </>)}

        {/* ── 2 · TU MEMBRESÍA ── */}
        {sec === 1 && (<>
          <h1 style={S.title}>{t('club.sec2')}</h1>
          <p style={S.desc}>{t('club.membresiaSub')}</p>
          <div style={S.aviso}>{t('club.avisoPlanes')}</div>
          {listaPlanes.map(p => (
            <div key={p.id} style={S.planCard(f.plan === p.id)} onClick={() => setF({ ...f, plan: p.id })}>
              <span style={{ width: 20, height: 20, borderRadius: '50%', border: `2px solid ${f.plan === p.id ? TEAL : '#c3d5d5'}`, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                {f.plan === p.id && <span style={{ width: 10, height: 10, borderRadius: '50%', background: TEAL }} />}
              </span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 800, color: '#16323a', fontSize: 15 }}>{p.nombre}</div>
                <div style={{ fontSize: 12.5, color: '#3a4e53' }}>{p.desc}</div>
              </div>
              <div style={{ fontWeight: 800, color: TEAL, fontSize: 15 }}>{p.precio}<span style={{ fontSize: 11, fontWeight: 600, color: '#7d9195' }}>{p.periodo}</span></div>
            </div>
          ))}
          <div style={S.gap} />
          <label style={S.label}>{t('club.comoConociste')} <span style={{ fontWeight: 500, color: '#7d9195' }}>{t('comun.opcional')}</span></label>
          <select value={f.como_conociste} onChange={set('como_conociste')} style={{ ...S.input(false), padding: '0 10px' }}>
            <option value="">{t('comun.selecciona')}</option>
            {COMO_CONOCISTE.map(c => <option key={c.valor} value={c.valor}>{t(c.clave)}</option>)}
          </select>
        </>)}

        {/* ── 3 · TU ACCESO ── */}
        {sec === 2 && (<>
          <h1 style={S.title}>{t('club.sec3')}</h1>
          <p style={S.desc}>{t('club.accesoSub')}</p>
          <label style={S.label}>{t('comun.password')}<Req /></label>
          <input type="password" value={f.pw1} onChange={set('pw1')} placeholder={t('comun.passwordSeguraPlaceholder')} style={S.input(false)} />
          {f.pw1.length > 0 && (
            <div style={{ margin: '6px 0 10px', display: 'flex', flexDirection: 'column', gap: 4 }}>
              {reglasPw.map((r, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: r.ok ? '#2f7d5a' : '#8a7a5a' }}>
                  <span style={{ width: 15, height: 15, borderRadius: '50%', flexShrink: 0, display: 'grid', placeItems: 'center', background: r.ok ? '#2f7d5a' : '#e2d9c6', color: '#fff', fontSize: 10 }}>{r.ok ? '✓' : ''}</span>{r.txt}
                </div>
              ))}
            </div>
          )}
          {f.pw1.length === 0 && <div style={S.gap} />}
          <label style={S.label}>{t('comun.repitePassword')}<Req /></label>
          <input type="password" value={f.pw2} onChange={set('pw2')} placeholder={t('comun.repitePlaceholder')} style={S.input(f.pw2 && f.pw1 !== f.pw2)} />
          {f.pw2 && f.pw1 !== f.pw2 ? <p style={S.err}>{t('comun.noCoinciden')}</p> : <div style={S.gap} />}
        </>)}

        {/* ── 4 · CONSENTIMIENTOS ── */}
        {sec === 3 && (<>
          <h1 style={S.title}>{t('club.sec4')}</h1>
          <p style={S.desc}>{t('club.consentSub')}</p>
          <label style={S.chk}>
            <input type="checkbox" checked={cons.privacidad} onChange={e => setCons({ ...cons, privacidad: e.target.checked })} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
            <span>{t('club.consPriv1')}<b>{t('club.consPrivStrong')}</b>{t('club.consPriv2')}<Req /></span>
          </label>
          <label style={S.chk}>
            <input type="checkbox" checked={cons.terminos} onChange={e => setCons({ ...cons, terminos: e.target.checked })} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
            <span>{t('club.consTerm1')}<b>{t('club.consTermStrong')}</b>{t('club.consTerm2')}<Req /></span>
          </label>
          <label style={S.chk}>
            <input type="checkbox" checked={cons.salud} onChange={e => setCons({ ...cons, salud: e.target.checked })} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
            <span>{t('club.consSalud1')}<b>{t('club.consSaludStrong')}</b>{t('club.consSalud2')}<span style={{ color: '#7d9195' }}>{t('club.consSaludNota')}</span></span>
          </label>
          <label style={S.chk}>
            <input type="checkbox" checked={cons.marketing} onChange={e => setCons({ ...cons, marketing: e.target.checked })} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
            <span>{t('club.consMark1')}<b>{t('club.consMarkStrong')}</b>{t('club.consMark2')}<span style={{ color: '#7d9195' }}>{t('comun.opcional')}</span></span>
          </label>
          <div style={{ fontSize: 11.5, color: '#8a9ca0', marginTop: 4 }}>{t('club.consFoot1')}<b>{t('club.consFootStrong')}</b>{t('club.consFoot2')}</div>
        </>)}

        {/* ── 5 · PAGO ── */}
        {sec === 4 && (<>
          <h1 style={S.title}>{t('club.sec5')}</h1>
          <p style={S.desc}>{t('club.pagoSub')}</p>
          <div style={{ border: '1px dashed #c3d5d5', borderRadius: 14, padding: '18px 16px', textAlign: 'center', background: '#f5faf9' }}>
            <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'center' }}>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>
            </div>
            <div style={{ fontWeight: 800, color: '#16323a', marginBottom: 6 }}>{t('club.pagoStripeTitulo')}</div>
            <p style={{ fontSize: 13, color: '#3a4e53', margin: 0 }}>{t('club.pagoStripe1')}<b>{t('club.pagoStripeStrong')}</b>{t('club.pagoStripe2')}</p>
          </div>
          <p style={{ fontSize: 12, color: '#8a9ca0', textAlign: 'center', marginTop: 12 }}>{t('club.fase1Nota')}</p>
        </>)}

        {/* ── navegación ── */}
        <div style={S.nav}>
          {sec > 0 && <button style={S.ghost} onClick={() => setSec(sec - 1)}>{t('comun.atras')}</button>}
          {sec < 4
            ? <button style={S.btn(!puedeAvanzar)} disabled={!puedeAvanzar} onClick={() => setSec(sec + 1)}>{t('comun.continuar')}</button>
            : <button style={S.btn(false)} onClick={() => setHecho(true)}>{t('club.registrarSolicitud')}</button>}
        </div>
      </div>
    </div>
  );
}
